// extracted by mini-css-extract-plugin
module.exports = {"row":"detail_row__2zaO-","label":"detail_label__57PUM","photoDetail":"detail_photoDetail__js_vm","photos":"detail_photos__1K_K2","photo":"detail_photo__3BAS-"};